import { render, staticRenderFns } from "./PlanDataTable.vue?vue&type=template&id=3fa934ed&scoped=true"
import script from "./PlanDataTable.vue?vue&type=script&lang=js"
export * from "./PlanDataTable.vue?vue&type=script&lang=js"
import style0 from "./PlanDataTable.vue?vue&type=style&index=0&id=3fa934ed&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa934ed",
  null
  
)

export default component.exports